import { faUserPen } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { MyProfileProps } from '../../AccountDetailsPage';
import { MyProfileContainer, MyProfileTitle, MyProfileTitleContainer } from '../../Desktop/MyProfile/styles'; // imported from desktop version as they are common between screens
import MobileMyProfileForm from './MobileMyProfileForm';

export default function MobileMyProfile({
  userDetailsFormState,
  handleMyProfileFormChange,
  submitMyProfileForm,
  userEmail,
  isApplyUserLoading,
}: MyProfileProps) {
  const { t } = useTranslation('accountDetails');

  return (
    <MyProfileContainer>
      <MyProfileTitleContainer>
        <FontAwesomeIcon icon={faUserPen} size="2x" />
        <MyProfileTitle>{t('myProfile')}</MyProfileTitle>
      </MyProfileTitleContainer>
      <MobileMyProfileForm
        userDetailsFormState={userDetailsFormState}
        handleMyProfileFormChange={handleMyProfileFormChange}
        submitMyProfileForm={submitMyProfileForm}
        userEmail={userEmail}
        isApplyUserLoading={isApplyUserLoading}
      />
    </MyProfileContainer>
  );
}
